/* QUIETUDE — home header pinning.

   The product page and the shared pages pin with CSS alone
   (quietude-sticky.css). The home cannot: its header sits inside
   .hy-stage, whose box ends with the hero, so position:sticky would
   unpin partway down the page. The header goes fixed instead, and the
   two thresholds below are what makes the switch invisible.

   Nothing here runs on a template without .hy-stage. */
(function () {
  function init() {
    var stage = document.querySelector('.hy-stage');
    if (!stage || stage.dataset.qtSticky) return;

    var root = stage.closest('.qt-home');
    var head = stage.querySelector('.hy-head');
    var hero = stage.querySelector('.hy-hero');
    if (!root || !head || !hero) return;
    stage.dataset.qtSticky = '1';

    var pinned = false, solid = false, queued = false;

    function apply() {
      queued = false;

      /* Positions, not a scroll offset. Horizon scrolls .page-wrapper —
         html and body are overflow:hidden — so window.scrollY sits at 0 for
         the whole page and any threshold measured against it never fires.
         A rect is read off whatever is actually scrolling.

         Pin the moment the stage reaches the top of the viewport: the
         header is the stage's first child, so it is already sitting against
         that edge and leaving the flow moves nothing on screen. The stage
         takes the header's height back as padding (see the stylesheet), so
         this rect does not move either — the state cannot oscillate. */
      var nextPinned = stage.getBoundingClientRect().top <= 0;

      /* Turn solid once the photograph has passed out from under the bar —
         glass needs something behind it, and below the hero there is only
         white. */
      var nextSolid = hero.getBoundingClientRect().bottom <= head.offsetHeight;

      if (nextPinned !== pinned) {
        pinned = nextPinned;
        root.classList.toggle('qt-stuck', pinned);
      }
      if (nextSolid !== solid) {
        solid = nextSolid;
        root.classList.toggle('qt-solid', solid);
      }
    }

    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(apply);
    }

    apply();
    /* Capture, because a scrolling element's event does not bubble and the
       one that scrolls here is .page-wrapper, not the window. The product
       rails scroll horizontally through here too; apply() is a pair of rect
       reads behind a rAF, so that costs nothing worth guarding against. */
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    addEventListener('resize', onScroll, { passive: true });
    /* The hero photograph settles its height late on a cold load, and the
       solid threshold is measured off it. */
    addEventListener('load', onScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* The theme editor rebuilds a section in place, taking the old header
     and its dataset flag with it. */
  document.addEventListener('shopify:section:load', init);
})();
